module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-96x96.6fd327dd637e8f438525db5a50d112b4.png";